import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import { useDispatch, useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { listHero } from "../actions/heroActions";
import Message from "./Message";
import Loader from "./Loader";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./Slider.css";

const carouselSettings = {
  showArrows: true,
  showStatus: false,
  showThumbs: false,
  infiniteLoop: true,
  useKeyboardArrows: true,
  autoPlay: true,
  stopOnHover: true,
  swipeable: true,
  dynamicHeight: true,
  emulateTouch: true,
  interval: 2000,
  transitionTime: 800,
  swipeScrollTolerance: 5,
};

export default function Hero({ cat }) {
  const dispatch = useDispatch();
  const { loading, heros, error } = useSelector((state) => state.heroList);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    dispatch(listHero("india", cat));
  }, [dispatch, cat]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const imgHeight = isMobile ? 240 : 320;

  return (
    <div>
      {loading ? (
        <div className={`w-full h-[${imgHeight}px] bg-white animate-pulse`}>
          <div className={`flex items-center justify-center h-[${imgHeight}px] bg-slate-100`}>
            <Loader />
          </div>
        </div>
      ) : error ? (
        <Message type="error">{error}</Message>
      ) : (
        <div className="w-full bg-white">
          <Carousel {...carouselSettings} showIndicators={heros.length > 1}>
            {heros.map((hero, index) => (
              <div key={index}>
                <RouterLink to={hero.link} className="block h-full">
                  <img
                    src={isMobile ? hero.urlMobImg : hero.url}
                    alt="banner"
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchpriority={index === 0 ? "high" : undefined}
                    decoding="async"
                    width={windowWidth}
                    height={imgHeight}
                    className={`w-full h-[${imgHeight}px] object-cover object-center`}
                  />
                </RouterLink>
              </div>
            ))}
          </Carousel>
        </div>
      )}
    </div>
  );
}
